module.exports = __webpack_public_path__ + "img/TopicPic.f2169b44.png";